import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider, MobxProvider } from '@ui-framework/index';
import { injectedStores } from './modules';
import App from './App';
import RootStore from './state/RootStore';
import { getKeyCloakConfigFromStorage } from './product-framework/pages/Login/components/KeycloakUserLoginForm';

const root = ReactDOM.createRoot(document.getElementById('root'));

const mobxRootStore = RootStore({ storesCollection: injectedStores });

function StrictModeWrapper({ forceDisabled = false, children }) {
  if (forceDisabled) {
    return children;
  }
  return <StrictMode>{children}</StrictMode>;
}

root.render(
  <StrictModeWrapper forceDisabled>
    <MobxProvider mobxRootStore={mobxRootStore}>
      <AuthProvider getKeyCloakConfigFromStorage={getKeyCloakConfigFromStorage}>
        <App
          style={{
            html: {
              'scroll-behavior': 'smooth',
            },
          }}
        />
      </AuthProvider>
    </MobxProvider>
  </StrictModeWrapper>,
);
